import dynamic from 'next/dynamic';

export default dynamic(() => import('./rich-text-input'), { ssr: false });

export { serializeRichText, deserializeRichText } from './rich-text-input';
